<template>
  <div class="full-background-loading"></div>
</template>

<script>
export default {
  name: "loading_bg",
  props: {}
};
</script>


